var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTaskCompleted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 2,
    fill: "#536DFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.854 17.354L18.708 11.5L17.479 10.271L12.854 14.896L10.542 12.583L9.312 13.812L12.854 17.354ZM6.5 21.5V6.50001H11.667C11.8337 6.00001 12.132 5.59734 12.562 5.29201C12.9927 4.98601 13.472 4.83301 14 4.83301C14.528 4.83301 15.0073 4.98601 15.438 5.29201C15.868 5.59734 16.1663 6.00001 16.333 6.50001H21.5V21.5H6.5ZM14 7.62501C14.1667 7.62501 14.3127 7.56267 14.438 7.43801C14.5627 7.31267 14.625 7.16667 14.625 7.00001C14.625 6.83334 14.5627 6.68734 14.438 6.56201C14.3127 6.43734 14.1667 6.37501 14 6.37501C13.8333 6.37501 13.6873 6.43734 13.562 6.56201C13.4373 6.68734 13.375 6.83334 13.375 7.00001C13.375 7.16667 13.4373 7.31267 13.562 7.43801C13.6873 7.56267 13.8333 7.62501 14 7.62501Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskCompleted);
export default __webpack_public_path__ + "static/media/task-completed.3663ea005364540f8bda180a005da08a.svg";
export { ForwardRef as ReactComponent };